var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uploadItem" }, [
    _c(
      "div",
      {
        staticClass: "image_poster",
        style: { width: _vm.width + "px", height: _vm.height + "px" },
      },
      [
        _vm.status === 1
          ? _c("div", [
              _c("div", [_vm._v("上传中(" + _vm._s(_vm.authProgress) + "%)")]),
            ])
          : _vm.status === 2
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                style: { width: _vm.width + "px", height: _vm.height + "px" },
                on: {
                  mouseenter: function ($event) {
                    _vm.alignUploadShow = true
                  },
                  mouseleave: function ($event) {
                    _vm.alignUploadShow = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-error",
                  staticStyle: { color: "#f53f3f", "font-size": "24px" },
                }),
                _c("div", { staticClass: "addimag_icon_error" }, [
                  _vm._v("上传失败"),
                ]),
                _c("transition", { attrs: { name: "slide" } }, [
                  _vm.alignUploadShow
                    ? _c(
                        "div",
                        { staticClass: "alignUploadShow" },
                        [
                          _c("svg-icon", {
                            staticClass: "alignUploadIcon",
                            attrs: { "icon-class": "alignUploadShow" },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("again")
                                },
                              },
                            },
                            [_vm._v("重新上传")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }